import InputText from '../../../../TextInput/TextInput';
import {
  VariableWrapper,
  VariableContainer,
  VariableHeader,
  VariableBody,
  VariableSelects
} from './Variable.styled';
import {CustomSelect, IconButton} from '../../../../../index'
import {OriginVariables} from "../../../../../../utils/enums";
import {observer} from "mobx-react";
import {useTemplateEditorStore} from "../../../hook";
import {useUserCheckPermissions} from "../../../../../../hooks/useUserCheckPermissions";
import {PermissionCodes} from "../../../../../../utils/enums";

const Variable = observer(({id}) => {
  const { variablesEditorStore } = useTemplateEditorStore();
  const { filteredSources } = variablesEditorStore;
  const currentVariable = variablesEditorStore.getVariable(id);
  const {checkPermission} = useUserCheckPermissions();

  return (
    <VariableWrapper>
      {(checkPermission(PermissionCodes.VARIABLES_SETUP, "UPDATE")) && (
              <IconButton
                  icon={!currentVariable.isOpened ? 'arrowDown' : 'arrowUp'}
                  width='12px'
                  height='12px'
                  onClick={() => variablesEditorStore.selectVariable(id)}
              />
          )}
      <VariableContainer>
        <VariableHeader>
          <InputText
            placeholder="Name Tag"
            width="90%"
            value={currentVariable.name}
            disabled={currentVariable.isDefault}
            onChange={(e) => variablesEditorStore.updateFieldVariable('name', id, e.target.value)}
          />
          <InputText
            placeholder="Internal Value"
            width="90%"
            value={currentVariable.variable}
            disabled={currentVariable.isDefault}
            onChange={(e) => variablesEditorStore.updateFieldVariable('variable', id, e.target.value)}
          />
          <span>
            {checkPermission(PermissionCodes.VARIABLES_SETUP, "DELETE") && (
            <IconButton
              icon={'coloredTrashcan'}
              disabled={currentVariable.isDefault}
              width={'15px'}
              onClick={() => variablesEditorStore.deleteVariable(id)}
            />
            )}
          </span> 
        </VariableHeader>
        {currentVariable.isOpened && <VariableBody>
          <div>
            <CustomSelect
              placeholder="Select type"
              width='90%'
              searchBar={false}
              disabled={currentVariable.isDefault}
              options={[
                {name: 'Fixed', value: OriginVariables.FIXED},
                {name: 'Event', value: OriginVariables.EVENT},
              ]}
              handleSelect={(_, value) => variablesEditorStore.updateFieldVariable('origin', id, value)}
              selectedDefault={currentVariable.origin}
            />
          </div>
          {
            currentVariable.origin === OriginVariables.FIXED &&
            (
              <InputText
                placeholder="Value"
                width="90%"
                value={currentVariable.value}
                onChange={(e) => variablesEditorStore.updateFieldVariable('value', id, e.target.value)}
              />
            )
          }
          {currentVariable.origin === OriginVariables.EVENT &&
            (
              <VariableSelects>
                <CustomSelect
                  width='45%'
                  placeholder='Source'
                  searchBar={false}
                  options={filteredSources}
                  handleSelect={(_, value) => variablesEditorStore.updateFieldVariable('source', id, value)}
                  selectedDefault={currentVariable.source}
                />
                <CustomSelect
                  width='45%'
                  searchBar={false}
                  placeholder='Field'
                  options={variablesEditorStore.getFilteredFields(currentVariable.source)}
                  handleSelect={(_, value) => variablesEditorStore.updateFieldVariable('field', id, value)}
                  selectedDefault={currentVariable.field}
                />
              </VariableSelects>
            )
          }
        </VariableBody>}
      </VariableContainer>
    </VariableWrapper>
  );
});

export default Variable